import React, { FunctionComponent, ReactElement, SVGAttributes } from "react";
import { Block, IBlockProps, Text } from "../../../seenspire-library";

export interface IEmptyTable extends IBlockProps {
  title?: string;
  description?: string;
  image?: ReactElement<SVGAttributes<SVGElement>>;
}

const EmptyTable: FunctionComponent<IEmptyTable> = ({
  title,
  description,
  image,
}) => {
  return (
    <Block
      display="grid"
      margin={{ top: 60, bottom: 60 }}
      textAlign="center"
      padding={{ all: 25 }}
      gridGap={20}
      justifyContent="center"
      alignItems="center"
    >
      <Block
        display="flex"
        justifyContent="center"
        justifyItems="center"
        fontSize="largest"
        color="gray"
        shade="lighter"
      >
        {image ? image : null}
      </Block>
      {title && (
        <Text color="gray" fontSize="largest">
          {title}
        </Text>
      )}
      <Text color="gray">
        {description || "It seems there is nothing to display!"}
      </Text>
    </Block>
  );
};

export default EmptyTable;
